import { defineComponent as _defineComponent } from 'vue'
import TemplateSelectorTreeComponent
  from '@/components/template/TemplateSelectorComponent/TemplateSelectorTreeComponent.vue'
import { ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { computed, PropType } from 'vue'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import { ITemplate } from '@/store/modules/template/templateTypes'
import { IFacturaEDialogModel } from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentTemplateSelectorComponent',
  props: {
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n()
const texts = {
  title: t('components.facturae_dialog.template_selector.title').toString(),
  caption: t('components.facturae_dialog.template_selector.caption').toString(),
  body: t('components.facturae_dialog.template_selector.body').toString(),
  cancel: t('action_buttons.cancel').toString(),
  generate: t('action_buttons.generate').toString(),
}
const buttons = computed(() => {
  return [
    {
      tooltip: texts.cancel,
      variant: LabelButtonVariant.OUTLINED,
      action: ActionName.CLOSE,
      enabled: true
    },
    {
      tooltip: texts.generate,
      variant: LabelButtonVariant.SOLID,
      action: ActionName.NEXT,
      enabled: !!props.model.selectedTemplate
    },
  ]
})

const { next, close, send } = useActionsFacturaEDialog(props.model)

function onTemplateSelected(templateSelected: ITemplate) {
  props.model.selectedTemplate = templateSelected
}

function onExecuteAction(action: string ) {
  switch (action) {
    case ActionName.NEXT:
      next()
      return
    case ActionName.CLOSE:
      close()
      return
    case ActionName.SEND_FACTURA_E:
      send()
      return
  }
}

return { __sfc: true,props, t, texts, buttons, next, close, send, onTemplateSelected, onExecuteAction, TemplateSelectorTreeComponent, LfActionsBarComponent, LfBlueTitleComponent }
}

})